// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useInboundCollateralAgreementRequestCountV2 } from '@hooks/other/useInboundCollateralAgreementRequestsV2';
import { Navigate } from 'react-router-dom';
import { Collateral } from '../../pages/collateralV2/collateral/Collateral';
import { Configurations } from '../../pages/collateralV2/configuration/Configurations';
import { Obligations } from '../../pages/collateralV2/obligations/Obligations';
import { Onboarding } from '../../pages/collateralV2/onboarding/Onboarding';
import { Agreements } from '../../pages/collateralV2/user/Agreements';
import { ModuleRoute } from '../../routes/types';

export const baseRoutes: ModuleRoute[] = [
  { index: true, element: <Navigate to="onboarding" /> },
  { label: 'Onboarding', path: 'onboarding', element: <Onboarding /> },
];

export const operatorRoutes: ModuleRoute[] = [
  { label: 'Configurations', path: 'configurations', element: <Configurations /> },
];

export const userRoutes: ModuleRoute[] = [
  {
    label: 'Agreements',
    path: 'agreements',
    element: <Agreements />,
    getNotificationHook: useInboundCollateralAgreementRequestCountV2,
  },
  {
    label: 'Collateral',
    path: 'collaterals',
    element: <Collateral />,
  },
  {
    label: 'Obligations',
    path: 'obligations',
    element: <Obligations />, // todo: use the correct hook for query instructions
  },
];

export const routes: ModuleRoute[] = [...baseRoutes, ...userRoutes, ...operatorRoutes];
